import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';

export const MyCardsRaritySwitcherBox = styled(ButtonBase)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--half-unit);
  padding: var(--unit);
  width: 64px;
  height: 64px;
  border-radius: var(--intermediate-unit);
  border: 1px solid var(--c-nd-150);
  & > * {
    opacity: 0.5;
  }
  &.active {
    border-color: var(--c-white);
    & > * {
      opacity: 1;
    }
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;
